<template>
    <div class="delete" v-if="currentObject">
        <el-link :underline="false" type="danger" icon="el-icon-delete" @click="handleDelete">
            Usuń
        </el-link>
    </div>
</template>

<script>
import Editor from '../../../classes/Editor'

export default {
    data() {
        return {
            currentObject: false,
            lastSelectedObject: false,
        }
    },
    methods: {
        handleDelete() {
            this.$confirm('Czy na pewno usunąć ten element?', 'Uwaga!', {
                type: 'warning',
                confirmButtonText: 'Tak',
            }).then(() => {
                Editor.canvas.remove(this.lastSelectedObject);
                Editor.canvas.renderAll();

                // Clear last selected object after remove
                this.lastSelectedObject = false
            })
        },
    },
    mounted() {
        Editor.addCallback(['selection:created', 'selection:updated'], () => {
            this.lastSelectedObject = this.currentObject = Editor.canvas.getActiveObject()
        })

        Editor.addCallback('selection:cleared', () => {
            this.currentObject = false
        })
    },
}
</script>

<style scoped>
.el-link,
.el-link.el-link--primary {
  margin: 0;
  font-weight: 400;
  font-size: 13px;
}
</style>